import { useMemo } from "react";
import {
  areObjectsEqual,
  hearingAidsOrderStructure,
  focusElement,
  hearingAidsTypeOptions,
  orderStatusList,
  inputOnEnter,
  selectedOptic,
  userData,
} from "../js/utils";
import InputIconSearch from "./InputIconSearch";
import InputData from "./InputData";
import Dropdown from "./Dropdown";
import { OrderActionButtons } from "./OrderActionButtons";
import { useModelsTradeNamesAndProducts } from "../hooks/useModelsTradeNamesAndProducts";
import { post } from "../js/post";
import { useOrderBase } from "../hooks/useOrderBase";

export function HearingAidsOrder({
  orderId,
  createPopupQuestion,
  removePopupQuestion,
  onSave,
  onClose,
}) {
  const {
    initialOrder,
    currentOrder,
    setCurrentOrder,
    currentOrderFixed,
    setCurrentOrderFixed,
    selectedSupplier,
    setSelectedSupplier,
    searchCode,
    setSearchCode,
    supplierList,
    brandList,
    validateOrder,
    focusFields,
    saveOrder,
    deleteOrder,
  } = useOrderBase({
    orderId,
    familia: 0,
    structure: hearingAidsOrderStructure,
    requiredFields: ["proveedor", "marca", "modelo"],
    fieldsToFocus: [
      { field: "proveedor", elementId: 51 },
      { field: "marca", elementId: 52 },
      { field: "modelo", elementId: 53 },
    ],
    saveEndpoint: "support-extra/pedidos/GuardarPedidoAudifono.php",
    getOrderEndpoint: "support-extra/pedidos/ObtenerPedidoAudifono.php",
    onSave,
    createPopupQuestion,
    removePopupQuestion,
  });
  const [rawModelsList] = useModelsTradeNamesAndProducts(
    [0],
    currentOrder.proveedor,
    currentOrder.marca !== "" ? [currentOrder.marca] : [],
  );
  const modelsList = useMemo(() => {
    return [
      { id: "", text: "" },
      ...rawModelsList.map((e) => ({
        id: e,
        text: e,
      })),
    ];
  }, [rawModelsList]);

  // console.log("orderId: ", orderId);
  // console.log("supplierList: ", supplierList);
  // console.log("currentOrder: ", currentOrder);
  // console.log("currentOrderFixed: ", currentOrderFixed);
  // console.log("selectedSupplier: ", selectedSupplier);

  async function getProduct() {
    const response = await post("ObtenerAudifono.php", {
      token: userData.token,
      codigo: searchCode,
      tipoCodigo: -1,
      idOptica: selectedOptic.id,
    });
    // console.log(
    // "BUSCANDO AUDÍFONO: ",
    // {
    // token: userData.token,
    // codigo: searchCode,
    // tipoCodigo: -1,
    // idOptica: selectedOptic.id,
    // },
    // response,
    // );
    if (response.id) {
      const productFields = {
        codigo: response.codigoOPTIWIN || response.codigoEANUPC,
        proveedor: response.idProveedor,
        marca: response.marca,
        modelo: response.modelo,
        tipo: response.tipo,
        entreDB: response.entreDB,
        hastaDB: response.hastaDB,
        nSerie: response.numeroSerie,
        refProveedor: response.referenciaProveedor,
      };
      setCurrentOrder((prev) => ({ ...prev, ...productFields }));
      setCurrentOrderFixed((prev) => ({ ...prev, ...productFields }));
      setSearchCode(productFields.codigo);
      const supplier = supplierList.find(
        (s) => s.id === parseInt(response.idProveedor),
      );
      if (supplier) setSelectedSupplier(supplier);
    } else {
      setCurrentOrder(initialOrder);
      setCurrentOrderFixed(initialOrder);
      setSelectedSupplier({ id: "", text: "" });
      createPopupQuestion(
        "Producto no encontrado.",
        async () => {
          focusElement(50);
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    }
  }

  return (
    <div className="popup-container">
      <div className="ap-container popup-screen">
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">Pedido de audífonos</span>
          <button
            className="popup-action-icon close-icon"
            onClick={() => {
              if (!areObjectsEqual(currentOrder, currentOrderFixed)) {
                createPopupQuestion(
                  "Existen cambios sin guardar. ¿Desea salir de la ficha de pedido?",
                  async () => {
                    removePopupQuestion();
                    onClose();
                  },
                  () => {
                    removePopupQuestion();
                  },
                  "Sí",
                  "No",
                );
              } else onClose();
            }}
          >
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
        </div>
        <div
          className="tab-content ap-content"
          style={{ overflow: "unset", backgroundColor: "#f9f9f9" }}
        >
          <div
            className="container-panel"
            style={{ display: "flex", flexDirection: "column", gap: 10 }}
          >
            <div className="opt-table-title">Datos del producto</div>
            <div className="opt-table-content grid-5" id="order-product-grid">
              <div className="cell cell-label cell-start-content">
                Código/EAN/UPC
              </div>
              <div className="cell">
                <InputIconSearch
                  tabIndex={50}
                  type="type-alphanum-ext"
                  size={0}
                  maxLength={10}
                  input={searchCode}
                  onChange={(e) => {
                    setSearchCode(e);
                  }}
                  onClear={() => {
                    focusElement(50);
                    setSearchCode("");
                  }}
                  onEnter={async () => {
                    if (searchCode) await getProduct();
                  }}
                ></InputIconSearch>
              </div>
              <div className="cell combined-cells-3"></div>
              <div className="cell cell-label cell-start-content">
                Proveedor (*)
              </div>
              <div className="cell combined-cells-4">
                <Dropdown
                  tabIndex={51}
                  optionList={supplierList}
                  size={0}
                  mandatory={true}
                  op={selectedSupplier.id}
                  onChange={(e) => {
                    // console.log("PROVEEDOR SELECCIONADO: ", e);
                    setSelectedSupplier(e);
                  }}
                ></Dropdown>
              </div>
              <div className="cell cell-label cell-start-content">
                Marca (*)
              </div>
              <div className="cell combined-cells-4">
                <Dropdown
                  tabIndex={52}
                  optionList={brandList}
                  size={0}
                  mandatory={false}
                  op={currentOrder.marca}
                  onChange={(e) => {
                    setCurrentOrder((prev) => ({
                      ...prev,
                      marca: e.text,
                    }));
                  }}
                ></Dropdown>
              </div>
              <div className="cell cell-label cell-start-content">
                Modelo (*)
              </div>
              <div className="cell">
                <Dropdown
                  tabIndex={53}
                  optionList={modelsList}
                  size={0}
                  mandatory={false}
                  op={currentOrder.modelo}
                  onChange={(e) => {
                    setCurrentOrder((prev) => ({
                      ...prev,
                      modelo: e.text,
                    }));
                  }}
                ></Dropdown>
              </div>
              <div className="cell"></div>
              <div className="cell cell-label cell-start-content">Entre dB</div>
              <div className="cell">
                <InputData
                  tabIndex={56}
                  type="type-integer"
                  size={0}
                  input={currentOrder.entreDB}
                  onChange={(e) => {
                    setCurrentOrder((prev) => ({
                      ...prev,
                      entreDB: e,
                    }));
                  }}
                ></InputData>
              </div>
              <div className="cell cell-label cell-start-content">Tipo</div>
              <div className="cell">
                <Dropdown
                  tabIndex={54}
                  optionList={hearingAidsTypeOptions}
                  size={0}
                  op={currentOrder.tipo}
                  onChange={(e) => {
                    setCurrentOrder((prev) => ({
                      ...prev,
                      tipo: e.text,
                    }));
                  }}
                ></Dropdown>
              </div>
              <div className="cell"></div>
              <div className="cell cell-label cell-start-content">Hasta dB</div>
              <div className="cell">
                <InputData
                  tabIndex={57}
                  type="type-integer"
                  size={0}
                  input={currentOrder.hastaDB}
                  onChange={(e) => {
                    setCurrentOrder((prev) => ({
                      ...prev,
                      hastaDB: e,
                    }));
                  }}
                ></InputData>
              </div>
              <div className="cell cell-label cell-start-content">Nº serie</div>
              <div className="cell">
                <InputData
                  tabIndex={55}
                  maxLength={20}
                  type="type-alphanum-ext"
                  size={0}
                  input={currentOrder.nSerie}
                  onChange={(e) => {
                    setCurrentOrder((prev) => ({
                      ...prev,
                      nSerie: e,
                    }));
                  }}
                ></InputData>
              </div>
              <div className="cell"></div>
              <div className="cell cell-label cell-start-content">
                Ref. proveedor
              </div>
              <div className="cell">
                <InputData
                  tabIndex={58}
                  maxLength={20}
                  type="type-alphanum-ext"
                  size={0}
                  input={currentOrder.refProveedor}
                  onChange={(e) => {
                    setCurrentOrder((prev) => ({
                      ...prev,
                      refProveedor: e,
                    }));
                  }}
                ></InputData>
              </div>
            </div>
            <div className="opt-table-title" style={{ marginTop: 20 }}>
              Datos del pedido:{" "}
              {currentOrder.idPedido === -1
                ? selectedOptic.nombre
                : currentOrder.nombreOptica}
            </div>
            <div className="opt-table-content grid-5" id="order-product-grid">
              <div className="cell cell-label cell-start-content">
                Fecha pedido
              </div>
              <div className="cell">
                <input
                  type="date"
                  max="9999-12-31"
                  tabIndex={59}
                  className="input-field input-cell"
                  value={currentOrder.fechaPedido}
                  onChange={(e) => {
                    setCurrentOrder((prev) => ({
                      ...prev,
                      fechaPedido: e.target.value,
                    }));
                  }}
                  onKeyUp={(e) => inputOnEnter(e)}
                ></input>
              </div>
              <div className="cell"></div>
              <div className="cell cell-label cell-start-content">Estado</div>
              <div className="cell">
                <Dropdown
                  tabIndex={61}
                  disabled={false}
                  optionList={orderStatusList}
                  size={0}
                  op={currentOrder.estado}
                  onChange={(e) => {
                    setCurrentOrder((prev) => ({
                      ...prev,
                      estado: e.id,
                    }));
                  }}
                ></Dropdown>
              </div>
              <div className="cell cell-label cell-start-content">
                Fecha recepción
              </div>
              <div className="cell">
                <input
                  type="date"
                  max="9999-12-31"
                  tabIndex={60}
                  className="input-field input-cell"
                  value={currentOrder.fechaRecepcion}
                  onChange={(e) => {
                    setCurrentOrder((prev) => ({
                      ...prev,
                      fechaRecepcion: e.target.value,
                    }));
                  }}
                  onKeyUp={(e) => inputOnEnter(e)}
                ></input>
              </div>
              <div className="cell"></div>
              <div className="cell cell-label cell-start-content">Unidades</div>
              <div className="cell">
                <button
                  className="incdec-btn"
                  onClick={() => {
                    setCurrentOrder((prev) => ({
                      ...prev,
                      unidades:
                        parseInt(prev.unidades) >= 2
                          ? parseInt(prev.unidades) - 1
                          : parseInt(prev.unidades),
                    }));
                  }}
                >
                  -
                </button>
                <div style={{ flex: 1 }}>
                  <InputData
                    tabIndex={62}
                    type="type-integer"
                    size={0}
                    input={currentOrder.unidades}
                    onChange={(e) => {
                      setCurrentOrder((prev) => ({
                        ...prev,
                        unidades: e,
                      }));
                    }}
                  ></InputData>
                </div>
                <button
                  className="incdec-btn"
                  onClick={() => {
                    setCurrentOrder((prev) => ({
                      ...prev,
                      unidades: parseInt(prev.unidades) + 1,
                    }));
                  }}
                >
                  +
                </button>
              </div>
            </div>
            <OrderActionButtons
              validateOrder={validateOrder}
              focusFields={focusFields}
              saveOrder={saveOrder}
              deleteOrder={deleteOrder}
              onSave={onSave}
              onClose={onClose}
              idPedido={currentOrder.idPedido}
              createPopupQuestion={createPopupQuestion}
              removePopupQuestion={removePopupQuestion}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
